export default __webpack_public_path__ + "static/media/po-color.23eec592.svg";